import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { menuToggler } from '@bd/bdcore-utilities';
import { colors, typography } from '../../styles';

const styles = css`
  display: none;
  @media (min-width: 992px) {
    display: block;
    position: relative;
    z-index: 1;
  }
  .DesktopNav_nav {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .DesktopNav_navItem {
    list-style: none;
    border-bottom: 1px solid ${colors.neutral};
    @media (min-width: 992px) {
      display: flex;
      position: relative;
      border: 0;
    }
  }
  .DesktopNav_navHeading {
    height: 60px;
    padding: 0 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    font-size: 17px;
    letter-spacing: 1px;
    font-weight: 700;
    text-transform: uppercase;
    color: ${colors.white};
    cursor: pointer;
    transition: all .3s ease;
    font-family: ${typography.Condensed};
    ${'' /* &::after {
      content: '';
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 6px solid ${colors.brand2};
      position: relative;
      margin: 0 0 0 5px;
    } */}
    &:hover, &:focus {
      outline: none;
      border: none;
      color: ${colors.brand2};
    }
    &-link {
      &::after {
        display: none;
      }
    }
  }
  .DesktopNav_menu {
    list-style: none;
    padding: 0 0 15px 0;
    margin: 0;
    position: relative;
    transition: all .3s ease;
    transition-delay: .1s;
    @media (min-width: 992px) {
      opacity: 0;
      transform: scaleY(0);
      transform-origin: top center;
      position: absolute;
      top: 55px;
      left: 0;
      width: 300px;
      background-color: ${colors.white};
      color: ${colors.white};
      padding: 30px;
      font-size: 15px;
      box-shadow: 0 5px 12px rgba(39,39,39,0.4);
      left: -15px;
    }
  }
  .DesktopNav_navItem:last-child .DesktopNav_menu {
    @media (min-width: 992px) {
      left: auto;
      right: -90px;
    }
  }
  .DesktopNav_menu-active {
    opacity: 1;
    transform: scaleY(1);
    display: block;
  }
  .DesktopNav_menuItemHeading {
    font-size: 17px;
    font-weight: 600;
    font-family: ${typography.Serif};
    color: ${colors.body};
    margin: 0 -30px 8px -30px;
    padding: 0 30px 0 30px;
    &:not(:first-child) {
      margin: 20px -30px 8px -30px;
      padding: 20px 30px 0 30px;
      border-top: 1px solid ${colors.neutral};
    }
    &:focus {
      outline: 0;
    }
  }
  .DesktopNav_menuItem a {
    color: ${colors.brand1Dark};
    padding: 4px 15px;
    display: block;
    transition: all .3s ease;
    background-color: ${colors.white};
    font-weight: 700;
    font-weight: 600;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: .5px;
    white-space: nowrap;
    &:hover {
      color: ${colors.brand2};
    }
  }
`;

function DesktopNav({ areas, isActiveMenu, activateMenu }) {
  return (
    <div className={styles} >
      <ul className="DesktopNav_nav">
        {
          areas.filter(area => area.isMetro).map(metro => (
            <li className="DesktopNav_navItem" key={metro.name}>
              <div tabIndex={0} role="button" onMouseEnter={activateMenu(metro.name)} onMouseLeave={activateMenu(null)} onKeyDown={activateMenu(metro.name)}>
                <span className="DesktopNav_navHeading">{metro.name}</span>
                <ul className={`${isActiveMenu(metro.name) ? 'DesktopNav_menu-active' : ''} DesktopNav_menu`}>
                  <li className="DesktopNav_menuItemHeading">Products</li>
                  <li className="DesktopNav_menuItem"><Link name="communities" params={{ communityMarketAreaMetro: get(metro, 'name') }}>Communities</Link></li>
                  <li className="DesktopNav_menuItem"><Link name="homes" params={{ communityMarketAreaMetro: get(metro, 'name') }}>Available Homes</Link></li>
                  {
                    metro.name === 'California' &&
                    <li className="DesktopNav_menuItem"><Link name="elliott-reserve">Turnkey Custom Homes</Link></li>
                  }
                  <li className="DesktopNav_menuItemHeading">Shop By Area</li>
                  {
                    areas.filter(area => area.parentMetro === metro.name).map(submetro => (
                      <li className="DesktopNav_menuItem" key={submetro.name}>
                        <Link
                          name="communities"
                          params={{
                            communityMarketAreaMetro: get(metro, 'name'),
                            communityMarketAreaSubMetro: get(submetro, 'name'),
                          }}
                          className="Menu_submetroListItemLink"
                        >
                          {submetro.name} New Homes
                        </Link>
                      </li>
                      ))
                    }
                </ul>
              </div>
            </li>
          ))
        }
        {/* <li className="DesktopNav_navItem">
          <Link className="DesktopNav_navHeading
          DesktopNav_navHeading-link" name="photo-gallery">Gallery</Link>
        </li> */}
      </ul>
    </div>
  );
}

DesktopNav.propTypes = {
  areas: PropTypes.arrayOf(PropTypes.object).isRequired,
  isActiveMenu: PropTypes.func.isRequired,
  activateMenu: PropTypes.func.isRequired,
};

export default withData(
  {
    areas: true,
  },
)(menuToggler((DesktopNav)));



// WEBPACK FOOTER //
// ./src/components/Header/DesktopNav.js